import { isEmpty } from 'lodash';
import { findCountryByCode } from './countries';

export const addressHelper = ({ Address, countries }) => {
  const {
    AptOrSuite,
    Street,
    City,
    State,
    PostalCode,
    CountryIso3Code,
  } = Address;

  if (
    !AptOrSuite &&
    !Street &&
    !City &&
    !State &&
    !PostalCode &&
    !CountryIso3Code
  ) {
    return '';
  }

  let addressString = '';

  if (AptOrSuite) {
    addressString += `${AptOrSuite}`;
  }

  if (Street) {
    addressString += `${Street}, `;
  }

  if (City) {
    addressString += `${City}, `;
  }
  if (State) {
    addressString += `${State}, `;
  }

  if (PostalCode) {
    addressString += `${PostalCode} `;
  }

  if (CountryIso3Code && !isEmpty(countries)) {
    addressString += `${findCountryByCode(countries, CountryIso3Code)} `;
  }

  return addressString;
};
